export const flushUiChangesHack = async () => {
  // TODO this is a hack to allow react updates to propagate and then paint on the screen.
  // Please use sparingly.  Generally it will be used as a temporary workaround to coordinate
  // changes to component state with re-rendering within react-flow.
  await new Promise(requestAnimationFrame);
  await new Promise(requestAnimationFrame);
};
